import DefaultRenderer from './default';
import filters from '../../components/filters';
import gsap from 'gsap';

class jobs extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		let mainScroll = this.mainController.getScroll();

		const { __ } = wp.i18n;

		// Filters
		let placeholders = document.getElementsByClassName('placeholder'),
			loadMoreContainer = document.getElementById('load-more-container'),
			loadMoreButton = document.getElementsByClassName('load-more')[0],
			newGrid = document.getElementById('new-container'),
			jobsCount = document.getElementById('number-count'),
			clearSelection = document.getElementById('clearSelection');

		let animateData = data => {
			let cardTl = gsap.timeline(),
				currentJobs = document.getElementsByClassName('job-card');

			cardTl.to(currentJobs, {
				duration: 0.4,
				x: 100,
				autoAlpha: 0,
				ease: 'back.easeIn.config(2)',
				stagger: 0.05,
				onComplete: () => {
					gsap.to([loadMoreContainer, loadMoreButton], {
						duration: 0,
						autoAlpha: 0,
						onComplete: () => {
							loadMoreContainer.style.display = 'none';
							loadMoreButton.style.display = 'none';
						},
					});

					let newJobs = [];
					newGrid.innerHTML = '';
					for (let index = 0; index < data.content.length; index++) {
						const newElement = data.content[index];
						let div = document.createElement('div');
						div.innerHTML = newElement.trim();
						let newJob = div.firstChild;
						gsap.set(newJob, {
							autoAlpha: 0,
							x: -100,
						});
						newGrid.appendChild(newJob);
						newJobs.push(newJob);
					}

					if (data.found !== jobsCount) {
						jobsCount.innerHTML = data.found;
					}

					gsap.fromTo(
						newJobs,
						{ x: -100 },
						{
							duration: 1.5,
							x: 0,
							autoAlpha: 1,
							ease: 'power4.out',
							stagger: 0.05,
						},
					);

					mainScroll.update();
				},
			});
		};

		filters('sodecia_job', animateData, mainScroll);

		clearSelection.addEventListener('click', function() {
			gsap.to(newGrid.getElementsByClassName('cell'), {
				duration: 0.4,
				x: 100,
				autoAlpha: 0,
				ease: 'expo.in',
				stagger: 0.05,
				onComplete: () => {
					newGrid.style.display = 'none';
					newGrid.innerHTML = '';

					gsap.to([loadMoreContainer, loadMoreButton], {
						duration: 0,
						autoAlpha: 1,
						onComplete: () => {
							loadMoreContainer.style.display = 'flex';
							loadMoreButton.style.display = 'flex';

							gsap.to(loadMoreContainer.getElementsByClassName('cell'), {
								duration: 1.2,
								x: 0,
								autoAlpha: 1,
								ease: 'power4.inOut',
								stagger: 0.05,
								onComplete: () => {
									if (mainScroll) {
										mainScroll.update();
									}
								},
							});
						},
					});
				},
			});

			gsap.to(this, { duration: 0.3, autoAlpha: 0, ease: 'power4.out' });

			for (let index = 0; index < placeholders.length; index++) {
				placeholders[index].classList.remove('chosen');
				placeholders[index].querySelector('span').innerHTML = __('Show all', 'sodecia');
			}
		});
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default jobs;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/jobs.js